import { useScrollArrows } from 'hooks/useScrollArrows';
import UpdateItem from './UpdateItem';
import Arrows from 'components/Charts/Arrows';
import { useState } from 'react';
import { RecentUpdateItem } from 'api/orders/schemas';

const UpdatesList = ({
  data,
  selected,
}: {
  data: RecentUpdateItem[] | undefined;
  selected: string[];
}) => {
  const { containerRef, isScrollable, scrollDirection, handleArrowClick } =
    useScrollArrows();

  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative w-full"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="vertical-scrollbar flex max-h-[230px] min-h-[230px] flex-col gap-4 overflow-y-auto overflow-x-hidden scrollbar-none"
        ref={containerRef}
      >
        {data?.length &&
        data?.filter((item) => selected.includes(item.type)).length ? (
          data
            ?.filter((item) => selected.includes(item.type))
            .map((item, index) => (
              <UpdateItem
                item={item}
                key={item.created_date}
                showDivider={index < data.length - 1}
              />
            ))
        ) : (
          <p className="font-bold">No recent updates</p>
        )}
      </div>
      {isScrollable && isHovered && (
        <Arrows
          handleArrowClick={handleArrowClick}
          scrollDirection={scrollDirection}
        />
      )}
    </div>
  );
};
export default UpdatesList;
